import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';

@Component({
  selector: 'app-chatbot',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule, MatButtonModule, MatInputModule, MatRadioModule],
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent {
  @Input() data: any;
  @Input() userName?: string | null;

  newMessage: string = '';
  selectedCategory: string | null = null;

  get messages(): any[] {
    return (this.data && Array.isArray(this.data.messages)) ? this.data.messages : [];
  }

  getUserInitial(): string {
    const name = this.userName || (this.data && this.data.userName) || '';
    const first = String(name || '').trim().charAt(0).toUpperCase();
    return first || 'U';
  }

  sendMessage() {
    if (!this.newMessage?.trim()) return;
    const msg = { from: 'user', text: this.newMessage.trim(), time: new Date().toISOString(), author: this.userName || null };
    if (this.data && Array.isArray(this.data.messages)) {
      this.data.messages.push(msg);
    }
    this.newMessage = '';
    setTimeout(() => {
      const reply = { from: 'bot', text: 'Thanks — we have received your message and will respond shortly.', time: new Date().toISOString() };
      if (this.data && Array.isArray(this.data.messages)) {
        this.data.messages.push(reply);
      }
    }, 800);
  }
}
